// @flow

import React, { useState } from 'react';

import { Icon, IconCheck, IconCopy } from '../../base/icons';
import { translate } from '../i18n';
import { copyText } from '../util';

function RPC_CopyButton({ className, displayedText, textToCopy, textOnHover, textOnCopySuccess }: Props) {
    const [ isClicked, setIsClicked ] = useState(false);

    async function onClick() {
        const isCopied = await copyText(textToCopy);
        if (isCopied) {
            setIsClicked(true);
            setTimeout(() => {
                setIsClicked(false);
            }, 2500);
        }
    }

    function renderContent() {
        if(isClicked) {
            return (<><IconCheck /> {textOnCopySuccess}</>)
        }
        return (<><IconCopy /> {displayedText}</>)
    }

    return (
        <a
            className = { `${isClicked ? ' clicked' : ''}` }
            onClick = { onClick }>
            { renderContent() }
        </a>
    );
}

RPC_CopyButton.defaultProps = {
    className: ''
};

export default translate(RPC_CopyButton);
